module.exports = __webpack_public_path__ + "static/media/no_ripples.492471bd.jpg";